export default item => {
  const quotes = item.quotations &&
    item.quotations.length > 0 &&
    item.quotations.filter(filterOnlyOneQuotation)

  return quotes
}

const filterOnlyOneQuotation = (item) => {
  return !item.notQuote && !!item.receiveDate && item.itemId
}



// WEBPACK FOOTER //
// ./src/view/item-pricing/helpers/FilterAvaliableQuotation.js